// Shared design tokens for the playful "desktop OS" portfolio.
// Palette is carried over from the original carousel design so the new
// experience keeps the same friendly, pastel personality.

export const colors = {
  // surfaces
  desktop: "#e9ede8",
  wallpaperTop: "#cdeee0",
  wallpaperBottom: "#f3e8ff",
  window: "#fdfdfb",
  windowHeader: "#f4f4f0",
  ink: "#1d1d1f",
  inkSoft: "#4c4c4c",
  inkFaint: "#8a8a8a",
  line: "#1d1d1f",

  // accents (from the original site)
  green: "#53DAA9",
  purple: "#863EFB",
  peach: "#FFAD8A",
  sky: "#5ED9E0",
  red: "#FF6969",
  lilac: "#B18DEB",
  butter: "#FFF0A0",
  orange: "#FF8E5E",

  // window controls
  close: "#FF6058",
  minimize: "#FFBD2E",
  maximize: "#28C940",
} as const;

// Chunky, hand-drawn-ish PostHog-style border + shadow.
export const border = `2px solid ${colors.line}`;
export const radius = {
  sm: "8px",
  md: "14px",
  lg: "20px",
  pill: "999px",
} as const;

export const shadow = {
  window: "6px 6px 0 rgba(29, 29, 31, 0.18)",
  windowFocused: "8px 8px 0 rgba(29, 29, 31, 0.28)",
  icon: "3px 3px 0 rgba(29, 29, 31, 0.18)",
  soft: "0 8px 24px rgba(29, 29, 31, 0.12)",
} as const;

export const font = {
  body: `'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  mono: `'Roboto Mono', source-code-pro, Menlo, Monaco, Consolas, monospace`,
} as const;

export const layout = {
  menuBarHeight: 40,
  dockHeight: 64,
  mobileBreakpoint: 768,
} as const;

export type AccentColor = (typeof colors)[keyof typeof colors];
